import { CruisesContract as API } from '@luxuryescapes/contract-svc-cruise';

import { CruiseShip, CruiseShipAmenity } from '~/components/Cruises/pages/Ships/types';

import cruisesAPI from './CruisesApiService';

const resource = 'ships';

const mapImage = (image: API.ShipImage): API.ShipImage => ({
  id: image.id,
  order: image.order,
  idImage: image.imageId,
  filename: image.filename,
  idCloudinaryExternal: image.imageId,
});

export type Ship = API.Ship;

const listWithPagination = async (paginationParams: API.ShipParams): Promise<API.Response<Array<API.Ship>>> => {
  return await cruisesAPI.http.get<Array<API.Ship>>({ resource, paginationParams });
};

const getShipById = async (shipId: string): Promise<API.Response<CruiseShip>> => {
  return await cruisesAPI.http.get<CruiseShip>({
    resource: `${resource}/${shipId}`,
  });
};

const updateShip = async (
  shipId: string,
  cruiseCriticId: number,
  isCrawlerAmenitiesCurated: boolean,
): Promise<API.Response<API.Ship>> => {
  return await cruisesAPI.http.put<API.Ship>({
    resource: `${resource}/${shipId}`,
    body: { cruiseCriticId, isCrawlerAmenitiesCurated },
  });
};

const getShipImages = async (shipId: string): Promise<API.Response<Array<API.ShipImage>>> => {
  const response = await cruisesAPI.http.get<Array<API.ShipImage>>({
    resource: `${resource}/${shipId}/images`,
  });

  return {
    ...response,
    result: response.result.map(mapImage),
  };
};

const createShipImage = async (
  shipId: string,
  image: {
    idCloudinaryExternal: string;
    filename?: string;
  },
): Promise<API.ShipImage> => {
  const response = await cruisesAPI.http.post<API.ShipImage>({
    resource: `${resource}/${shipId}/images`,
    body: {
      imageId: image.idCloudinaryExternal,
      filename: image.filename,
    },
  });
  return mapImage(response);
};

const updateShipImages = async (
  shipId: string,
  images: Array<{
    idImage: string;
    idCloudinaryExternal: string;
    order: string;
  }>,
) => {
  await cruisesAPI.http.put({
    resource: `${resource}/${shipId}/images`,
    body: {
      images: images.map((image) => ({
        imageId: image.idImage,
      })),
    },
  });
};

const deleteShipImage = async (shipId: string, imageId: string) => {
  await cruisesAPI.http.delete({
    resource: `${resource}/${shipId}/images/${imageId}`,
  });
};

const getShipAmenities = async (shipId: string): Promise<API.Response<Array<CruiseShipAmenity>>> => {
  return await cruisesAPI.http.get<Array<CruiseShipAmenity>>({
    resource: `${resource}/${shipId}/amenities`,
  });
};

export default {
  getShipById,
  updateShip,
  getShipImages,
  createShipImage,
  deleteShipImage,
  updateShipImages,
  listWithPagination,
  getShipAmenities,
};
